var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 94,
    viewBox: "0 0 93 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "page-performance-speed-dashboard-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1687 32.4687C7.1687 31.6127 7.86266 30.9187 8.7187 30.9187H84.2812C85.1372 30.9187 85.8312 31.6127 85.8312 32.4687C85.8312 33.3247 85.1372 34.0187 84.2812 34.0187H8.7187C7.86266 34.0187 7.1687 33.3247 7.1687 32.4687Z",
    fill: "#DCE4E9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 20.3438,
    cy: 23.75,
    r: 2.90625,
    fill: "#DCE4E9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 29.0625,
    cy: 23.75,
    r: 2.90625,
    fill: "#DCE4E9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 37.7812,
    cy: 23.75,
    r: 2.90625,
    fill: "#DCE4E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.9375 73.1562C70.9125 73.1562 77.0156 76.6437 80.5031 81.875C82.8281 78.6781 84.2812 74.6094 84.2812 70.25C84.2812 58.9156 75.2719 49.9062 63.9375 49.9062C52.6031 49.9062 43.5938 58.9156 43.5938 70.25C43.5938 74.6094 45.0469 78.6781 47.3719 81.875C50.8594 76.6437 56.9625 73.1562 63.9375 73.1562Z",
    fill: "#2A9D8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0437 70.25C42.0437 58.0595 51.747 48.3562 63.9375 48.3562C76.1279 48.3562 85.8312 58.0595 85.8312 70.25C85.8312 74.9527 84.2648 79.3379 81.7566 82.7866C81.4584 83.1967 80.9784 83.435 80.4715 83.4246C79.9645 83.4143 79.4947 83.1566 79.2134 82.7347C76.0101 77.9297 70.3883 74.7062 63.9375 74.7062C57.4866 74.7062 51.8648 77.9297 48.6615 82.7347C48.3802 83.1566 47.9104 83.4143 47.4034 83.4246C46.8965 83.435 46.4165 83.1967 46.1183 82.7866C43.6101 79.3379 42.0437 74.9527 42.0437 70.25ZM63.9375 51.4562C53.4591 51.4562 45.1437 59.7716 45.1437 70.25C45.1437 73.4873 46.0144 76.5533 47.4739 79.1632C51.3619 74.5536 57.2903 71.6062 63.9375 71.6062C70.5846 71.6062 76.513 74.5536 80.401 79.1632C81.8605 76.5533 82.7312 73.4873 82.7312 70.25C82.7312 59.7716 74.4158 51.4562 63.9375 51.4562Z",
    fill: "#DCE4E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1687 15.0312C7.1687 14.1752 7.86266 13.4812 8.7187 13.4812H84.2812C85.1372 13.4812 85.8312 14.1752 85.8312 15.0312V35.375C85.8312 36.231 85.1372 36.9249 84.2812 36.9249C83.4252 36.9249 82.7312 36.231 82.7312 35.375V16.5812H10.2687V77.4187H43.5937C44.4497 77.4187 45.1437 78.1127 45.1437 78.9687C45.1437 79.8247 44.4497 80.5187 43.5937 80.5187H8.7187C7.86266 80.5187 7.1687 79.8247 7.1687 78.9687V15.0312Z",
    fill: "#DCE4E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5863 60.2913C74.2711 60.8049 74.4099 61.7765 73.8963 62.4613L65.1775 74.0863C64.6639 74.7711 63.6924 74.9099 63.0075 74.3963C62.3227 73.8827 62.1839 72.9111 62.6975 72.2263L71.4163 60.6013C71.9299 59.9165 72.9015 59.7777 73.5863 60.2913Z",
    fill: "#DCE4E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.2812 30.9187C85.1372 30.9187 85.8312 31.6127 85.8312 32.4687V70.25C85.8312 71.106 85.1372 71.7999 84.2812 71.7999C83.4252 71.7999 82.7312 71.106 82.7312 70.25V32.4687C82.7312 31.6127 83.4252 30.9187 84.2812 30.9187Z",
    fill: "#DCE4E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7937 44.0937C18.7937 43.2377 19.4877 42.5437 20.3437 42.5437H34.875C35.731 42.5437 36.425 43.2377 36.425 44.0937C36.425 44.9497 35.731 45.6437 34.875 45.6437H20.3437C19.4877 45.6437 18.7937 44.9497 18.7937 44.0937Z",
    fill: "#DCE4E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7937 52.8125C18.7937 51.9564 19.4877 51.2625 20.3437 51.2625H26.1562C27.0122 51.2625 27.7062 51.9564 27.7062 52.8125C27.7062 53.6685 27.0122 54.3625 26.1562 54.3625H20.3437C19.4877 54.3625 18.7937 53.6685 18.7937 52.8125Z",
    fill: "#DCE4E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.58bebcfc9b0523834c48d9870d526bbb.svg";
export { ForwardRef as ReactComponent };